export default {
  getStoreInfo: (data, option) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({
          position: [-79.42328879939049, 43.662323158433864],
          name: 'Shop'
        })
      }, 600);
    });
  },
  getGoogleMapsApiKey: (token, option) => {
    return new Promise((resolve, reject) => {
      resolve({
        data: "AIzaSyCPQ7yyCSARlX-6J1WVfPl_0Q-NR65tAYs"
      })
    })
    // return new Promise((resolve, reject) => {
    // 	let xhr = new XMLHttpRequest();
    // 	xhr.open('get', process.env.VUE_APP_GET_GOOGLE_MAP_API_KEY_URL);
    // 	// xhr.setRequestHeader('token', token);
    // 	xhr.onreadystatechange = () => {
    // 		if (xhr.readyState === 4) {
    // 			if (xhr.status === 200) {
    // 				let data = xhr.responseText;
    // 				try {
    // 					data = JSON.parse(data);
    // 				} catch (e) {
    // 					//
    // 				}
    // 				resolve(data);
    // 			} else {
    // 				reject(xhr.status);
    // 			}
    // 		}
    // 	}
    // 	xhr.send();
    // });
  }
}
